export const PENDING = 'Pending'
export const REGISTRATION = 'Registration'
export const SELLING = 'Selling'

export default {
  PENDING,
  REGISTRATION,
  SELLING,
}
